export const INDICATOR_LOAD_MONITORING = 'indicatorLoadMonitoring';

export const INDICATOR_LOAD_MONITORING_ACTIONS_NAME = {
  getMonitoringPage: `${INDICATOR_LOAD_MONITORING}/getMonitoringPage`,
  getUpdateStatuses: `${INDICATOR_LOAD_MONITORING}/getUpdateStatuses`,
  getSources: `${INDICATOR_LOAD_MONITORING}/getSources`,
};

export const INDICATOR_LOAD_MONITORING_MUTATIONS_NAME = {
  setMonitoringPage: `${INDICATOR_LOAD_MONITORING}/setMonitoringPage`,
  setUpdateStatuses: `${INDICATOR_LOAD_MONITORING}/setUpdateStatuses`,
  setSources: `${INDICATOR_LOAD_MONITORING}/setSources`,
  setLoadError: `${INDICATOR_LOAD_MONITORING}/setLoadError`,
};

export const INDICATOR_LOAD_MONITORING_GETTERS_NAME = {
  getMonitoringPage: `${INDICATOR_LOAD_MONITORING}/getMonitoringPage`,
  getUpdateStatuses: `${INDICATOR_LOAD_MONITORING}/getUpdateStatuses`,
  getSources: `${INDICATOR_LOAD_MONITORING}/getSources`,
  getLoadError: `${INDICATOR_LOAD_MONITORING}/getLoadError`,
};
